import classNames from "classnames/bind";
import styles from "./ConfigSpace.module.css";
import TableListConfig from "../../TableListConfig";
import { Col, Row } from "antd";
import { Alert, Button, Empty, Loading, Toast } from "../../../../components";
import { manageNotification } from "../../../../services/api/manageNotification";
import { useEffect, useRef, useState } from "react";
import { columns, listIconLevel } from "./configTableConfigSpace";
import axiosClient from "../../../../services/axiosClient";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { listAiTranslate, listParamLevelTranslate } from "../../../../utils";

const cx = classNames.bind(styles);

function ConfigSpace({ cameraInfo }) {
    const [listType, setListType] = useState([]);
    const [listTypeAi, setListTypeAi] = useState([]);
    const [listTypeSystem, setListTypeSystem] = useState([]);
    const [valueConfig, setValueConfig] = useState([]);
    const [valueAiChange, setValueAiChange] = useState();
    const [valueSystemChange, setValueSystemChange] = useState();
    const refFormAI = useRef(null);
    const refFormSystem = useRef(null);
    const [loading, setLoading] = useState(false);
    const [colTable, setColTable] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [companyCode, setCameraCode] = useState("");
    const [alertConectTele, setAlertConectTele] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    // Trả ra danh sách mức cảnh báo
    const getListNotificationLevel = async () => {
        try {
            const res = await manageNotification.getListNotificationLevel();
            if (res) {
                const listVal = res?.map(item => {
                    const level = listIconLevel?.find(lv => lv?.CODE === item?.CODE)
                    return {
                        label: <div className={cx('select-item')}>{level?.ICON || ""} {listParamLevelTranslate.find(paLv => paLv.param_name === item?.DETAIL)?.name_tr || item?.DETAIL}</div>,
                        value: item?.CODE
                    }
                })
                return listVal;
            }
            return [];
        } catch (error) {
            throw error;
        }
    }
    // Lấy ra trạng thái liên kết tele
    const getStateTelegram = async () => {
        try {
            const res = await manageNotification.getStateConnectTelegram();
            return res;
        } catch (error) {
            throw error;
        }
    }
    // Xử lý các cột cho bảng
    useEffect(() => {
        const getColTable = async () => {
            try {
                const listLevelNoti = await getListNotificationLevel();
                const stateTele = await getStateTelegram();
                const listCol = columns?.map((item) => {
                    if (item?.key === 'notification_level_code') {
                        return {
                            ...item,
                            options: listLevelNoti
                        }
                    }
                    if (item?.key === 'telegram' && stateTele?.status !== 'connected') {
                        return {
                            ...item,
                            props: {
                                ...item?.props,
                                onChange: () => setAlertConectTele(!alertConectTele)
                            },
                        }
                    }
                    return {
                        ...item
                    }
                })
                setColTable(listCol)
            } catch (error) {
                // console.log(error);
            }
        }
        getColTable()
    }, [columns])

    // Trả ra màu của tùng ai
    const getListColorRegister = async () => {
        try {
            // const res = await manageNotification.getListService();
            return [];
            // // console.log("res", res);
        } catch (error) {
            // console.log('eeeeee', error);
        }
    }
    // Trả ra giá trị của các cảnh báo của cam được chọn
    const getListCameraNotification = async (cameraCode) => {
        setLoading(true)
        try {
            const param = {
                camera_code: cameraCode
            }
            const res = await manageNotification.getListCameraNotification(param);
            if (res?.length > 0) {
                setValueConfig(res);
            } else {
                const defaultSys = await manageNotification.getListCameraNotificationDefault();
                setValueConfig(defaultSys);
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            // console.log(error);
            Toast.open("Lấy thông tin cài đặt không thành công", "danger")
        }
    }
    // Lấy thông tin cam để lấy ra mã cty
    const getInfoCamera = async (code) => {
        try {
            const res = await axiosClient.get(`cameraManagement/get-camera-info-by-code/?camera_code=${code}`)
            setCameraCode(res[0]?.CODE);
        } catch (error) {
            // console.log(error);

        }
    }
    // Trả ra danh sách các tên cảnh báo và add màu cảnh báo tương ứng với nó, hiện mới có AI chưa có system
    const getListNotifycationType = async () => {
        try {
            const res = await manageNotification.getListNotificationType();
            const listColorAi = await getListColorRegister();
            if (res) {
                const listNotificationTypeAddColor = res?.map((item) => {
                    const colorAI = listColorAi?.find(clAi => clAi?.NOTIFICATION_TYPE_CODE === item?.CODE)?.COLOR || "";
                    return {
                        ...item,
                        EVENT_COLOR: colorAI
                    }
                })
                setListType(listNotificationTypeAddColor);
            }
        } catch (error) {
            throw error;
        }
    }

    useEffect(() => {
        getListNotifycationType();
    }, [])
    useEffect(() => {
        if (cameraInfo?.code) {
            getListCameraNotification(cameraInfo?.code);
            getInfoCamera(cameraInfo?.code);
        }
    }, [cameraInfo?.code, refresh])

    const handleSubType = (listTypeAddValue) => {
        const listNotificationTypeAI = listTypeAddValue?.filter(item => item?.ai_service_code !== null) || [];
        const listNotificationTypeSystem = listTypeAddValue?.filter(item => item?.ai_service_code === null) || [];
        setListTypeAi(listNotificationTypeAI);
        setListTypeSystem(listNotificationTypeSystem);
    }
    // lấy ra mảng chứa đầy đủ thông tin cấu hình của từng loại cảnh báo theo giá trị của từng cam
    useEffect(() => {
        const listTypeAddValue = listType?.map(item => {
            const listConfigOfCode = valueConfig?.filter(val => val?.NOTIFICATION_TYPE_CODE === item?.CODE);
            let statusApp = 0;
            let statusTele = 0;
            listConfigOfCode.forEach(item => {
                if (item?.METHOD === "APP") {
                    statusApp = item?.STATUS;
                }
                if (item?.METHOD === "TELEGRAM") {
                    statusTele = item?.STATUS;
                }
            })

            const value = listConfigOfCode[listConfigOfCode?.length - 1];
            return {
                notification_level_code: value?.NOTIFICATION_LEVEL_CODE || "",
                telegram: statusTele === 1,
                app: statusApp === 1,
                alert_time: value?.ALERT_TIME || "",
                event_color: value?.COLOR || "",
                type_code: item?.CODE || "",
                detail: listAiTranslate.find(ai => ai.ai_name === item?.DETAIL)?.name_tr || item?.DETAIL || "",
                ai_service_code: item?.AI_SERVICE_CODE,
            }
        })
        handleSubType(listTypeAddValue);
    }, [listType, valueConfig])

    // Lấy thông tin từ form ai
    const handleChangeValueAi = (valConfig) => {
        setValueAiChange(valConfig?.configs)
    }
    // Lấy thông tin từ formsystem 
    const handleChangeValueSystem = (valueConfig) => {
        setValueSystemChange(valueConfig?.configs)
    }

    const handleRefresh = () => {
        setRefresh(!refresh)
    }

    const hanldeSave = () => {
        if (refFormAI && refFormSystem) {
            refFormAI?.current?.submit();
            refFormSystem?.current?.submit();
        } else {
            Toast.open("Lỗi thông tin khi sửa", "danger")
        }
    }
    const saveConfig = async (infoUpdate) => {
        setLoading(true)
        try {
            // const color = infoUpdate?.map(item => {
            //     return {
            //         notification_type_code: item?.type_code || "",
            //         color: item?.event_color?.substring(1) || "",
            //     }
            // })
            // // console.log("infoUpdate", infoUpdate);

            const newInfoUpdate = infoUpdate?.flatMap(item => {
                const valConfig = {
                    alert_time: item?.alert_time || null,
                    notification_level_code: item?.notification_level_code || "",
                    notification_type_code: item?.type_code || "",
                    color: item?.event_color?.substring(1) || "",
                }
                console.log('event-color',item?.event_color);
                
                const result = [
                    { ...valConfig, method: "TELEGRAM", status: item?.telegram ? 1 : 0 },
                    { ...valConfig, method: "APP", status: item?.app ? 1 : 0 }
                ]
                return result;
            })
            // const bodyColor = {
            //     company_code: companyCode,
            //     list_cam_noti: {
            //         data: color
            //     }
            // }
            // // console.log(newInfoUpdate);

            const bodyValue = {
                camera_code: cameraInfo?.code,
                list_cam_noti: {
                    data: newInfoUpdate
                }
            }
            await manageNotification?.postAddCameraNotification(bodyValue)
            // await manageNotification?.postAddNotificationColor(bodyColor);
            setValueAiChange();
            setValueSystemChange();
            Toast.open("Lưu cài đặt Thông báo thành công", "success");
            handleRefresh();
            setLoading(false);
        } catch (error) {
            // console.log(error);
            setLoading(false);
            Toast.open('Lưu cài đặt Thông báo không thành công', 'danger');
            setValueAiChange();
            setValueSystemChange();
        }
    }
    // Thụ động call api save khi có they đổi thông tin
    useEffect(() => {
        if (valueAiChange && valueSystemChange) {
            const infoUpdate = [...valueAiChange, ...valueSystemChange];
            saveConfig(infoUpdate);
        }
    }, [valueAiChange, valueSystemChange, cameraInfo?.code, companyCode])
    const handleConect = () => {
        navigate("/admin/notification/manage-chanel")
    }
    const hanldeReDefault = async () => {
        // Lấy ra mặc định
        try {
            const defaultSys = await manageNotification.getListCameraNotificationDefault();
            // Xử lý payload
            const listTypeAddValue = listType?.map(item => {
                const listConfigOfCode = defaultSys?.filter(val => val?.NOTIFICATION_TYPE_CODE === item?.CODE);
                let statusApp = 0;
                let statusTele = 0;
                listConfigOfCode.forEach(item => {
                    if (item?.METHOD === "APP") {
                        statusApp = item?.STATUS;
                    }
                    if (item?.METHOD === "TELEGRAM") {
                        statusTele = item?.STATUS;
                    }
                })
                const value = listConfigOfCode[listConfigOfCode?.length - 1];
                return {
                    notification_level_code: value?.NOTIFICATION_LEVEL_CODE || "",
                    telegram: statusTele === 1,
                    app: statusApp === 1,
                    alert_time: value?.ALERT_TIME || "",
                    event_color: value?.COLOR ? `#${value?.COLOR}` : "",
                    type_code: item?.CODE || "",
                    detail: item?.DETAIL || "",
                    ai_service_code: item?.AI_SERVICE_CODE,
                }
            })
            // post lại lên saveConfig
            await saveConfig(listTypeAddValue)
        } catch (error) {
            // console.log(error);
        }

    }
    return (
        <>
            {alertConectTele && <Alert title={"Tài khoản chưa liên kết telegram"} onOk={handleConect} />}
            {loading ? <div className={cx("loading")}><Loading /></div> : (
                <>
                    {cameraInfo?.code ? (<>
                        <div className={cx('config')}>
                            <TableListConfig
                                name={t('header.smartNoification')}
                                dataSource={listTypeAi}
                                onChange={(valConfig) => handleChangeValueAi(valConfig)}
                                ref={refFormAI}
                                columns={colTable}
                            />
                        </div>
                        <div className={cx('config')}>
                            <TableListConfig
                                name={t('setupNotification.System_warning')}
                                dataSource={listTypeSystem}
                                onChange={(valConfig) => handleChangeValueSystem(valConfig)}
                                ref={refFormSystem}
                                columns={colTable}
                            />
                        </div>
                        <Row gap={[0, 16]}>
                            <Col span={24}>
                                <div className={cx('footer')}>
                                    <Button title={t('stream.cancelCustom')} className={cx('btn', 'cancel')} onClick={handleRefresh} />
                                    <Button title={t('setting.Reset_to_default')} className={cx('btn')} onClick={hanldeReDefault} />
                                    <Button title={t('settingCam.Save_settings')} className={cx('btn')} onClick={hanldeSave} />
                                </div>
                            </Col>
                        </Row>
                    </>) : <Empty title={t("setupNotification.Select_camera_to_view_settings_information")} />}
                </>
            )}
        </>
    )
}

export default ConfigSpace;